import type { ExperimentViewedEvent } from './ExperimentViewedEvent';
import { experimentViewedSchema } from './ExperimentViewedSchema';

export const experimentViewedToEvent = ({
  experimentId,
  variationId,
}: {
  experimentId: string;
  variationId: string;
}): ExperimentViewedEvent => {
  const event: ExperimentViewedEvent = {
    schema: experimentViewedSchema.ref,
    data: {
      experiment_id: experimentId,
      variation_id: variationId,
    },
  };

  return event;
};
